/**
 * Created by Parcye on 7-3-2017.
 */
window.onerror = function(message, file, line) {
	logError(file + ':' + line + '\n\n' + message);
};

function logError(details) {
	$.ajax({
		type: 'POST',
		url: window.base_url + 'errorlog.php',
		data: JSON.stringify({context: navigator.userAgent, details: details}),
		contentType: 'application/json; charset=utf-8'
	});
}

$(document).ajaxError(function(e, xhr, settings) {
	logError(settings.url + ':' + xhr.status + '\n\n' + xhr.responseText);
});